{% block sw_first_run_wizard_finish %}
    <div class="sw-first-run-wizard-finish">
        <ecocode-trustpilot-invitation-recover ref="invitation"></ecocode-trustpilot-invitation-recover>
        <p>
            {{ $tc('ecocode-trustpilot.invitation.processLater') }}
        </p>
    </div>
{% endblock %}
